/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AvatarMeListingVariantSkuEnumItem,
  BatchGetSellerCustomersRequest,
  BatchGetSellerCustomersResponse,
  BuyerStats,
  CollectionLayoutTypeEnumItem,
  CommunityChannelMemberSearchResponse,
  CommunityChannelMemberStatusEnumItem,
  CommunityChannelMessageSearchResponse,
  CommunityChannelSearchResponse,
  GroupEventLocationTypeEnumItem,
  GroupEventSearchResponse,
  LeadsContactSearchTypeEnumItem,
  ModerationStatusEnumItem,
  MyStoreListingSearchResponse,
  OrderEnumItem,
  OrdersSearchResponse,
  PollSearchResponse,
  PollVoteSearchResponse,
  PopStoreUserAccessLevelEnumItem,
  PostCommentSearchResponse,
  PostSearchResponse,
  PostStatusEnumItem,
  ProductCategoriesSearchResponse,
  ProductCollectionsSearchResponse,
  ProfilesFollowersSearchResponse,
  SearchAccountsResponse,
  SearchCommunityChannelMemberSortByEnumItem,
  SearchCommunityChannelMessageSortByEnumItem,
  SearchCommunityChannelSortByEnumItem,
  SearchGroupEventSortByEnumItem,
  SearchLeadContactSortByEnumItem,
  SearchLeadFormContactResponse,
  SearchLeadFormContactSortByEnumItem,
  SearchLeadFormResponse,
  SearchLeadFormSortByEnumItem,
  SearchLeadFormSubmissionResponse,
  SearchLeadFormSubmissionSortByEnumItem,
  SearchLeadsContactsV2Response,
  SearchPersonalLookResponse,
  SearchPersonalLookSortByEnumItem,
  SearchPollSortByEnumItem,
  SearchPollVoteSortByEnumItem,
  SearchPopStoreThemeTemplatePurposeEnumItem,
  SearchPostCommentSortByEnumItem,
  SearchPostSortByEnumItem,
  SearchPurchasedAvatarMeMediaResponse,
  SearchPurchasedAvatarMeMediaSortByEnumItem,
  SearchSellerCustomerOrdersFilters,
  SearchSellerCustomerOrdersParams,
  SearchSellerCustomerOrdersResponse,
  SearchSellerCustomersParams,
  SearchSellerCustomersResponse,
  SearchSellerLifeTimeStatsResponse,
  SearchSeriesElementsSortByEnumItem,
  SearchTippingGoalSortByEnumItem,
  SearchTokenListingRequestTypeEnumItem,
  SearchTokenListingResponse,
  SearchTokenListingSortByEnumItem,
  SellerCustomerOrdersSummaryResponse,
  SellerCustomerSummaryResponse,
  SellerCustomersFilterParams,
  SeriesElementModerationStatusEnumItem,
  SeriesElementSearchResponseV2,
  SeriesSearchResponse,
  SeriesTypeEnumItem,
  StoreListingSearchResponse,
  TippingGoalSearchResponse,
  TippingGoalStatusEnumItem,
  UpcomingShowSearchResponse,
  WithdrawTransactionsSearchResponse,
} from '../models/index';

export interface SearchApiControllerAggregateSellerCustomerOrdersRequest {
    sellerId: string;
    SearchSellerCustomerOrdersFilters: SearchSellerCustomerOrdersFilters;
}

export interface SearchApiControllerAggregateSellerCustomerSummaryRequest {
    sellerId: string;
    SellerCustomersFilterParams: SellerCustomersFilterParams;
}

export interface SearchApiControllerBatchGetSellerCustomersRequest {
    sellerId: string;
    BatchGetSellerCustomersRequest: BatchGetSellerCustomersRequest;
}

export interface SearchApiControllerExportSellerOrderDetailsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerExportSellerOrderDetailsOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerExportSellerOrderDetailsStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerExportSellerOrderDetailsPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerExportSellerOrderDetailsGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerExportSellerOrderDetailsShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum;
    platform?: SearchApiControllerExportSellerOrderDetailsPlatformEnum;
    listingType?: SearchApiControllerExportSellerOrderDetailsListingTypeEnum;
    showTitle?: string;
    noLiveStreamId?: boolean;
    mainOrderNumber?: string;
    mainStatus?: Array<SearchApiControllerExportSellerOrderDetailsMainStatusEnum>;
    mainPacked?: boolean;
    showCreatedBefore?: string;
    showCreatedAfter?: string;
    shippingLabelStatus?: Array<SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum>;
    mainShippingLabelStatus?: Array<SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum>;
    shippingStatus?: SearchApiControllerExportSellerOrderDetailsShippingStatusEnum;
    rateStatus?: SearchApiControllerExportSellerOrderDetailsRateStatusEnum;
    mainShippingStatus?: SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum;
    filterLabelStatus?: SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum;
    sortBy?: SearchApiControllerExportSellerOrderDetailsSortByEnum;
    paymentType?: Array<SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum>;
    transactionDateBefore?: string;
    transactionDateAfter?: string;
    isUsingShippoPlatform?: boolean;
    loadShippingCosts?: boolean;
    minWeight?: number;
    maxWeight?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sourceType?: SearchApiControllerExportSellerOrderDetailsSourceTypeEnum;
    sourceId?: string;
    timezone?: string;
}

export interface SearchApiControllerGetBuyerStatsForGivenStoreRequest {
    storeId: string;
    buyerId: string;
}

export interface SearchApiControllerSearchAccountsRequest {
    pageNo: number;
    pageSize: number;
    query?: string;
    isSeller?: boolean;
    x_pop_platform?: SearchApiControllerSearchAccountsXPopPlatformEnum;
}

export interface SearchApiControllerSearchActiveLeadFormsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    active?: boolean;
    triggerActionKeys?: Array<string>;
    sortBy?: SearchLeadFormSortByEnumItem;
}

export interface SearchApiControllerSearchActiveTokenListingRequest {
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    type?: Array<SearchTokenListingRequestTypeEnumItem>;
    active?: boolean;
    sortBy?: SearchTokenListingSortByEnumItem;
}

export interface SearchApiControllerSearchLeadFormContactsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    leadFormId?: Array<string>;
    storeId2?: Array<string>;
    sortBy?: SearchLeadFormContactSortByEnumItem;
}

export interface SearchApiControllerSearchLeadFormsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    active?: boolean;
    triggerActionKeys?: Array<string>;
    sortBy?: SearchLeadFormSortByEnumItem;
}

export interface SearchApiControllerSearchLeadsContactsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    storeId2?: Array<string>;
    sourceType?: Array<string>;
    sourceId?: Array<string>;
    query?: string;
    sortBy?: SearchLeadContactSortByEnumItem;
}

export interface SearchApiControllerSearchLeadsContactsV2Request {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    sourceType?: Array<string>;
    sourceId?: Array<string>;
    query?: string;
    type?: LeadsContactSearchTypeEnumItem;
    sortBy?: SearchLeadContactSortByEnumItem;
}

export interface SearchApiControllerSearchMyStoreListingsRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchMyStoreListingsOrderEnum;
    id?: Array<string>;
    type?: Array<SearchApiControllerSearchMyStoreListingsTypeEnum>;
    excludeType?: Array<SearchApiControllerSearchMyStoreListingsExcludeTypeEnum>;
    query?: string;
    status?: SearchApiControllerSearchMyStoreListingsStatusEnum;
    filterOutLiveListings?: boolean;
    loadLiveStatus?: boolean;
    slug?: string;
    tags?: Array<string>;
    soldOut?: boolean;
    minPrice?: number;
    maxPrice?: number;
    shopifyStoreIds?: Array<string>;
    sortBy?: SearchApiControllerSearchMyStoreListingsSortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum;
    supplierId?: number;
    partnerId?: number;
    collectionId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    isDropship?: boolean;
    isShopify?: boolean;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    fromTemplate?: boolean;
    extraState?: Array<string>;
}

export interface SearchApiControllerSearchMySubmittedCollectedLeadFormSubmissionsRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    leadFormId?: Array<string>;
    storeId?: Array<string>;
    sortBy?: SearchLeadFormSubmissionSortByEnumItem;
}

export interface SearchApiControllerSearchPersonalLooksRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    isDefault?: boolean;
    sortBy?: SearchPersonalLookSortByEnumItem;
}

export interface SearchApiControllerSearchPostsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    id?: Array<string>;
    permaLink?: string;
    moderationStatus?: Array<ModerationStatusEnumItem>;
    status?: Array<PostStatusEnumItem>;
    minScheduledReleaseTime?: string;
    maxScheduledReleaseTime?: string;
    sortBy?: SearchPostSortByEnumItem;
    x_pop_platform?: SearchApiControllerSearchPostsXPopPlatformEnum;
}

export interface SearchApiControllerSearchPostsCommentsRequest {
    storeId: string;
    postId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    rootComment?: boolean;
    id?: Array<string>;
    parentId?: string;
    sortBy?: SearchPostCommentSortByEnumItem;
}

export interface SearchApiControllerSearchProductCollectionsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchProductCollectionsOrderEnum;
    query?: string;
    slug?: string;
    id?: Array<string>;
    archived?: boolean;
    loadLinkedProductCategories?: boolean;
    layoutType?: CollectionLayoutTypeEnumItem;
    sortBy?: SearchApiControllerSearchProductCollectionsSortByEnum;
}

export interface SearchApiControllerSearchProductsRequest {
    pageNo: number;
    pageSize: number;
    query?: string;
    x_pop_platform?: SearchApiControllerSearchProductsXPopPlatformEnum;
}

export interface SearchApiControllerSearchProfilesFollowersRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchProfilesFollowersOrderEnum;
    query?: string;
    expand?: boolean;
    withPhoneNumber?: boolean;
    withSubscriptionLevel?: boolean;
    sortBy?: SearchApiControllerSearchProfilesFollowersSortByEnum;
}

export interface SearchApiControllerSearchPslCategoriesRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPslCategoriesOrderEnum;
    query?: string;
    id?: Array<string>;
    parentId?: string;
    isRoot?: boolean;
    enabled?: boolean;
    custom?: boolean;
    digital?: boolean;
    loadLinkedGoogleCategories?: boolean;
    sortBy?: SearchApiControllerSearchPslCategoriesSortByEnum;
}

export interface SearchApiControllerSearchPublicListingsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPublicListingsOrderEnum;
    id?: Array<string>;
    query?: string;
    slug?: string;
    categoryRowId?: string;
    categoryId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    collectionId?: string;
    tags?: Array<string>;
    sellerTags?: Array<string>;
    status?: SearchApiControllerSearchPublicListingsStatusEnum;
    minQuantity?: number;
    sortBy?: SearchApiControllerSearchPublicListingsSortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum;
    sellerIds?: Array<string>;
    featured?: boolean;
    prefetchFeaturedStatus?: boolean;
    listingType?: Array<SearchApiControllerSearchPublicListingsListingTypeEnum>;
    excludeListingType?: Array<SearchApiControllerSearchPublicListingsExcludeListingTypeEnum>;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
    extraState?: Array<string>;
    x_pop_platform?: SearchApiControllerSearchPublicListingsXPopPlatformEnum;
}

export interface SearchApiControllerSearchPublicListingsV2Request {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchPublicListingsV2OrderEnum;
    id?: Array<string>;
    query?: string;
    slug?: string;
    categoryRowId?: string;
    categoryId?: string;
    productCategoryId?: Array<string>;
    includeChildCategories?: boolean;
    collectionId?: string;
    tags?: Array<string>;
    sellerTags?: Array<string>;
    status?: SearchApiControllerSearchPublicListingsV2StatusEnum;
    minQuantity?: number;
    sortBy?: SearchApiControllerSearchPublicListingsV2SortByEnum;
    tagsFilterOperator?: SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum;
    sellerIds?: Array<string>;
    featured?: boolean;
    prefetchFeaturedStatus?: boolean;
    listingType?: Array<SearchApiControllerSearchPublicListingsV2ListingTypeEnum>;
    excludeListingType?: Array<SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum>;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
    extraState?: Array<string>;
    x_pop_platform?: SearchApiControllerSearchPublicListingsV2XPopPlatformEnum;
}

export interface SearchApiControllerSearchPurchasedAvatarMeMediaFromMeRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    id?: Array<string>;
    orderId?: Array<string>;
    storeId2?: Array<string>;
    variantSku?: Array<AvatarMeListingVariantSkuEnumItem>;
    wearWithAiListingId?: Array<string>;
    sortBy?: SearchPurchasedAvatarMeMediaSortByEnumItem;
}

export interface SearchApiControllerSearchSellerCustomerOrdersRequest {
    sellerId: string;
    SearchSellerCustomerOrdersParams: SearchSellerCustomerOrdersParams;
}

export interface SearchApiControllerSearchSellerCustomersRequest {
    sellerId: string;
    SearchSellerCustomersParams: SearchSellerCustomersParams;
}

export interface SearchApiControllerSearchSellerLifeTimeStatsRequest {
    sellerId: string;
}

export interface SearchApiControllerSearchSellerOrdersRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSellerOrdersOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerSearchSellerOrdersStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerSearchSellerOrdersPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerSearchSellerOrdersGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerSearchSellerOrdersShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum;
    platform?: SearchApiControllerSearchSellerOrdersPlatformEnum;
    listingType?: SearchApiControllerSearchSellerOrdersListingTypeEnum;
    noLiveStreamId?: boolean;
    sortBy?: SearchApiControllerSearchSellerOrdersSortByEnum;
    sellerId?: string;
    buyerId?: string;
    listingId?: string;
    tippingGoalId?: string;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
}

export interface SearchApiControllerSearchSeriesRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSeriesOrderEnum;
    query?: string;
    slug?: string;
    id?: Array<string>;
    accessLevel?: Array<PopStoreUserAccessLevelEnumItem>;
    popClipId?: Array<string>;
    type?: Array<SeriesTypeEnumItem>;
    parentId?: Array<string>;
    archived?: boolean;
    fromTemplate?: boolean;
    sortBy?: SearchApiControllerSearchSeriesSortByEnum;
}

export interface SearchApiControllerSearchSeriesElementsV2Request {
    storeId: string;
    seriesId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchSeriesElementsV2OrderEnum;
    query?: string;
    id?: Array<string>;
    popClipId?: Array<string>;
    includeElementsFromSubSeries?: boolean;
    moderationStatus?: SeriesElementModerationStatusEnumItem;
    sortBy?: SearchSeriesElementsSortByEnumItem;
}

export interface SearchApiControllerSearchStoreCommunityChannelMembersRequest {
    storeId: string;
    channelId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    id?: Array<string>;
    blocked?: boolean;
    status?: CommunityChannelMemberStatusEnumItem;
    sortBy?: SearchCommunityChannelMemberSortByEnumItem;
}

export interface SearchApiControllerSearchStoreCommunityChannelMessagesRequest {
    storeId: string;
    channelId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    parentMessageId?: string;
    level?: number;
    id?: Array<string>;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    pinnedOnly?: boolean;
    sortBy?: SearchCommunityChannelMessageSortByEnumItem;
    cursor?: string;
}

export interface SearchApiControllerSearchStoreCommunityChannelsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    slug?: string;
    id?: Array<string>;
    sortBy?: SearchCommunityChannelSortByEnumItem;
}

export interface SearchApiControllerSearchStoreGroupEventsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    listingId?: string;
    locationType?: GroupEventLocationTypeEnumItem;
    minStartDate?: string;
    maxStartDate?: string;
    sortBy?: SearchGroupEventSortByEnumItem;
}

export interface SearchApiControllerSearchStoreLevelSeriesElementsV2Request {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum;
    query?: string;
    id?: Array<string>;
    popClipId?: Array<string>;
    includeElementsFromSubSeries?: boolean;
    moderationStatus?: SeriesElementModerationStatusEnumItem;
    sortBy?: SearchSeriesElementsSortByEnumItem;
}

export interface SearchApiControllerSearchStorePollVotesRequest {
    storeId: string;
    pollId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    userId?: string;
    optionId?: string;
    deviceId?: string;
    unifiedId?: string;
    id?: Array<string>;
    sortBy?: SearchPollVoteSortByEnumItem;
}

export interface SearchApiControllerSearchStorePollsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    slug?: string;
    id?: Array<string>;
    sortBy?: SearchPollSortByEnumItem;
}

export interface SearchApiControllerSearchStoreTippingGoalsRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    order?: OrderEnumItem;
    query?: string;
    slug?: string;
    status?: TippingGoalStatusEnumItem;
    sortBy?: SearchTippingGoalSortByEnumItem;
}

export interface SearchApiControllerSearchThemeTemplatesRequest {
    storeId: string;
    pageNo: number;
    pageSize: number;
    purpose: SearchPopStoreThemeTemplatePurposeEnumItem;
    order?: SearchApiControllerSearchThemeTemplatesOrderEnum;
    id?: Array<string>;
    name?: string;
    sortBy?: SearchApiControllerSearchThemeTemplatesSortByEnum;
    type?: string;
}

export interface SearchApiControllerSearchUpcomingShowsRequest {
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUpcomingShowsOrderEnum;
    id?: Array<string>;
    query?: string;
    storeName?: string;
    userId?: string;
    available?: boolean;
    noEventId?: boolean;
    loadWatchListCount?: boolean;
    minStartsAt?: string;
    maxStartsAt?: string;
    sortBy?: SearchApiControllerSearchUpcomingShowsSortByEnum;
}

export interface SearchApiControllerSearchUserOrdersRequest {
    userId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchUserOrdersOrderEnum;
    ids?: Array<string>;
    query?: string;
    masterOrderId?: Array<string>;
    orderNumber?: string;
    liveStreamId?: string;
    status?: Array<SearchApiControllerSearchUserOrdersStatusEnum>;
    orderGroupStatus?: Array<SearchApiControllerSearchUserOrdersOrderGroupStatusEnum>;
    pickupStatus?: Array<SearchApiControllerSearchUserOrdersPickupStatusEnum>;
    groupStatusMaster?: boolean;
    groupStatus?: Array<SearchApiControllerSearchUserOrdersGroupStatusEnum>;
    packed?: boolean;
    allOrders?: boolean;
    shippingMethod?: Array<SearchApiControllerSearchUserOrdersShippingMethodEnum>;
    createdBefore?: string;
    createdAfter?: string;
    couponCode?: string;
    aggregateTax?: boolean;
    buyerUserType?: SearchApiControllerSearchUserOrdersBuyerUserTypeEnum;
    platform?: SearchApiControllerSearchUserOrdersPlatformEnum;
    listingType?: SearchApiControllerSearchUserOrdersListingTypeEnum;
    noLiveStreamId?: boolean;
    sortBy?: SearchApiControllerSearchUserOrdersSortByEnum;
    sellerId?: string;
    buyerId?: string;
    listingId?: string;
    tippingGoalId?: string;
    minMeetingStartDate?: string;
    maxMeetingStartDate?: string;
}

export interface SearchApiControllerSearchWithdrawTransactionsBySellerRequest {
    sellerId: string;
    pageNo: number;
    pageSize: number;
    order?: SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum;
    id?: Array<string>;
    query?: string;
    status?: Array<SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum>;
    userId?: string;
    minCreatedAt?: string;
    maxCreatedAt?: string;
    sortBy?: SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     */
    async searchApiControllerAggregateSellerCustomerOrdersRaw(requestParameters: SearchApiControllerAggregateSellerCustomerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SellerCustomerOrdersSummaryResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerAggregateSellerCustomerOrders().'
            );
        }

        if (requestParameters['SearchSellerCustomerOrdersFilters'] == null) {
            throw new runtime.RequiredError(
                'SearchSellerCustomerOrdersFilters',
                'Required parameter "SearchSellerCustomerOrdersFilters" was null or undefined when calling searchApiControllerAggregateSellerCustomerOrders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/customer-orders:aggregate`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SearchSellerCustomerOrdersFilters'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateSellerCustomerOrders(requestParameters: SearchApiControllerAggregateSellerCustomerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SellerCustomerOrdersSummaryResponse> {
        const response = await this.searchApiControllerAggregateSellerCustomerOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerAggregateSellerCustomerSummaryRaw(requestParameters: SearchApiControllerAggregateSellerCustomerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SellerCustomerSummaryResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerAggregateSellerCustomerSummary().'
            );
        }

        if (requestParameters['SellerCustomersFilterParams'] == null) {
            throw new runtime.RequiredError(
                'SellerCustomersFilterParams',
                'Required parameter "SellerCustomersFilterParams" was null or undefined when calling searchApiControllerAggregateSellerCustomerSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/customers:aggregate`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SellerCustomersFilterParams'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerAggregateSellerCustomerSummary(requestParameters: SearchApiControllerAggregateSellerCustomerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SellerCustomerSummaryResponse> {
        const response = await this.searchApiControllerAggregateSellerCustomerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerBatchGetSellerCustomersRaw(requestParameters: SearchApiControllerBatchGetSellerCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BatchGetSellerCustomersResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerBatchGetSellerCustomers().'
            );
        }

        if (requestParameters['BatchGetSellerCustomersRequest'] == null) {
            throw new runtime.RequiredError(
                'BatchGetSellerCustomersRequest',
                'Required parameter "BatchGetSellerCustomersRequest" was null or undefined when calling searchApiControllerBatchGetSellerCustomers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/customers:batch-get`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['BatchGetSellerCustomersRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerBatchGetSellerCustomers(requestParameters: SearchApiControllerBatchGetSellerCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BatchGetSellerCustomersResponse> {
        const response = await this.searchApiControllerBatchGetSellerCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerExportSellerOrderDetailsRaw(requestParameters: SearchApiControllerExportSellerOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerExportSellerOrderDetails().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerExportSellerOrderDetails().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerExportSellerOrderDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['masterOrderId'] != null) {
            queryParameters['masterOrderId'] = requestParameters['masterOrderId'];
        }

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        if (requestParameters['liveStreamId'] != null) {
            queryParameters['liveStreamId'] = requestParameters['liveStreamId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['orderGroupStatus'] != null) {
            queryParameters['orderGroupStatus'] = requestParameters['orderGroupStatus'];
        }

        if (requestParameters['pickupStatus'] != null) {
            queryParameters['pickupStatus'] = requestParameters['pickupStatus'];
        }

        if (requestParameters['groupStatusMaster'] != null) {
            queryParameters['groupStatusMaster'] = requestParameters['groupStatusMaster'];
        }

        if (requestParameters['groupStatus'] != null) {
            queryParameters['groupStatus'] = requestParameters['groupStatus'];
        }

        if (requestParameters['packed'] != null) {
            queryParameters['packed'] = requestParameters['packed'];
        }

        if (requestParameters['allOrders'] != null) {
            queryParameters['allOrders'] = requestParameters['allOrders'];
        }

        if (requestParameters['shippingMethod'] != null) {
            queryParameters['shippingMethod'] = requestParameters['shippingMethod'];
        }

        if (requestParameters['createdBefore'] != null) {
            queryParameters['createdBefore'] = requestParameters['createdBefore'];
        }

        if (requestParameters['createdAfter'] != null) {
            queryParameters['createdAfter'] = requestParameters['createdAfter'];
        }

        if (requestParameters['couponCode'] != null) {
            queryParameters['couponCode'] = requestParameters['couponCode'];
        }

        if (requestParameters['aggregateTax'] != null) {
            queryParameters['aggregateTax'] = requestParameters['aggregateTax'];
        }

        if (requestParameters['buyerUserType'] != null) {
            queryParameters['buyerUserType'] = requestParameters['buyerUserType'];
        }

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['listingType'] != null) {
            queryParameters['listingType'] = requestParameters['listingType'];
        }

        if (requestParameters['showTitle'] != null) {
            queryParameters['showTitle'] = requestParameters['showTitle'];
        }

        if (requestParameters['noLiveStreamId'] != null) {
            queryParameters['noLiveStreamId'] = requestParameters['noLiveStreamId'];
        }

        if (requestParameters['mainOrderNumber'] != null) {
            queryParameters['mainOrderNumber'] = requestParameters['mainOrderNumber'];
        }

        if (requestParameters['mainStatus'] != null) {
            queryParameters['mainStatus'] = requestParameters['mainStatus'];
        }

        if (requestParameters['mainPacked'] != null) {
            queryParameters['mainPacked'] = requestParameters['mainPacked'];
        }

        if (requestParameters['showCreatedBefore'] != null) {
            queryParameters['showCreatedBefore'] = requestParameters['showCreatedBefore'];
        }

        if (requestParameters['showCreatedAfter'] != null) {
            queryParameters['showCreatedAfter'] = requestParameters['showCreatedAfter'];
        }

        if (requestParameters['shippingLabelStatus'] != null) {
            queryParameters['shippingLabelStatus'] = requestParameters['shippingLabelStatus'];
        }

        if (requestParameters['mainShippingLabelStatus'] != null) {
            queryParameters['mainShippingLabelStatus'] = requestParameters['mainShippingLabelStatus'];
        }

        if (requestParameters['shippingStatus'] != null) {
            queryParameters['shippingStatus'] = requestParameters['shippingStatus'];
        }

        if (requestParameters['rateStatus'] != null) {
            queryParameters['rateStatus'] = requestParameters['rateStatus'];
        }

        if (requestParameters['mainShippingStatus'] != null) {
            queryParameters['mainShippingStatus'] = requestParameters['mainShippingStatus'];
        }

        if (requestParameters['filterLabelStatus'] != null) {
            queryParameters['filterLabelStatus'] = requestParameters['filterLabelStatus'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['paymentType'] != null) {
            queryParameters['paymentType'] = requestParameters['paymentType'];
        }

        if (requestParameters['transactionDateBefore'] != null) {
            queryParameters['transactionDateBefore'] = requestParameters['transactionDateBefore'];
        }

        if (requestParameters['transactionDateAfter'] != null) {
            queryParameters['transactionDateAfter'] = requestParameters['transactionDateAfter'];
        }

        if (requestParameters['isUsingShippoPlatform'] != null) {
            queryParameters['isUsingShippoPlatform'] = requestParameters['isUsingShippoPlatform'];
        }

        if (requestParameters['loadShippingCosts'] != null) {
            queryParameters['loadShippingCosts'] = requestParameters['loadShippingCosts'];
        }

        if (requestParameters['minWeight'] != null) {
            queryParameters['minWeight'] = requestParameters['minWeight'];
        }

        if (requestParameters['maxWeight'] != null) {
            queryParameters['maxWeight'] = requestParameters['maxWeight'];
        }

        if (requestParameters['minQuantity'] != null) {
            queryParameters['minQuantity'] = requestParameters['minQuantity'];
        }

        if (requestParameters['maxQuantity'] != null) {
            queryParameters['maxQuantity'] = requestParameters['maxQuantity'];
        }

        if (requestParameters['sourceType'] != null) {
            queryParameters['sourceType'] = requestParameters['sourceType'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['sourceId'] = requestParameters['sourceId'];
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/order-details:export`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async searchApiControllerExportSellerOrderDetails(requestParameters: SearchApiControllerExportSellerOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.searchApiControllerExportSellerOrderDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerGetBuyerStatsForGivenStoreRaw(requestParameters: SearchApiControllerGetBuyerStatsForGivenStoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuyerStats>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerGetBuyerStatsForGivenStore().'
            );
        }

        if (requestParameters['buyerId'] == null) {
            throw new runtime.RequiredError(
                'buyerId',
                'Required parameter "buyerId" was null or undefined when calling searchApiControllerGetBuyerStatsForGivenStore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/buyers/{buyerId}:stats`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));
        urlPath = urlPath.replace(`{${"buyerId"}}`, encodeURIComponent(String(requestParameters['buyerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerGetBuyerStatsForGivenStore(requestParameters: SearchApiControllerGetBuyerStatsForGivenStoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuyerStats> {
        const response = await this.searchApiControllerGetBuyerStatsForGivenStoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchAccountsRaw(requestParameters: SearchApiControllerSearchAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchAccountsResponse>> {
        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchAccounts().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['isSeller'] != null) {
            queryParameters['isSeller'] = requestParameters['isSeller'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/accounts:search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchAccounts(requestParameters: SearchApiControllerSearchAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchAccountsResponse> {
        const response = await this.searchApiControllerSearchAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for anonymous users to search a creator\'s active lead forms
     */
    async searchApiControllerSearchActiveLeadFormsRaw(requestParameters: SearchApiControllerSearchActiveLeadFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadFormResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchActiveLeadForms().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchActiveLeadForms().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchActiveLeadForms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['triggerActionKeys'] != null) {
            queryParameters['triggerActionKeys'] = requestParameters['triggerActionKeys'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/active-lead-forms:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for anonymous users to search a creator\'s active lead forms
     */
    async searchApiControllerSearchActiveLeadForms(requestParameters: SearchApiControllerSearchActiveLeadFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadFormResponse> {
        const response = await this.searchApiControllerSearchActiveLeadFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for anonymous users to search active token listings
     */
    async searchApiControllerSearchActiveTokenListingRaw(requestParameters: SearchApiControllerSearchActiveTokenListingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchTokenListingResponse>> {
        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchActiveTokenListing().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchActiveTokenListing().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/active-token-listings:search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for anonymous users to search active token listings
     */
    async searchApiControllerSearchActiveTokenListing(requestParameters: SearchApiControllerSearchActiveTokenListingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchTokenListingResponse> {
        const response = await this.searchApiControllerSearchActiveTokenListingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for creators to search his/her collected lead form contacts
     * @deprecated
     */
    async searchApiControllerSearchLeadFormContactsRaw(requestParameters: SearchApiControllerSearchLeadFormContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadFormContactResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchLeadFormContacts().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchLeadFormContacts().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchLeadFormContacts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['leadFormId'] != null) {
            queryParameters['leadFormId'] = requestParameters['leadFormId'];
        }

        if (requestParameters['storeId2'] != null) {
            queryParameters['storeId'] = requestParameters['storeId2'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/lead-form-contacts:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for creators to search his/her collected lead form contacts
     * @deprecated
     */
    async searchApiControllerSearchLeadFormContacts(requestParameters: SearchApiControllerSearchLeadFormContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadFormContactResponse> {
        const response = await this.searchApiControllerSearchLeadFormContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for creators to search his/her lead forms
     */
    async searchApiControllerSearchLeadFormsRaw(requestParameters: SearchApiControllerSearchLeadFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadFormResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchLeadForms().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchLeadForms().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchLeadForms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['triggerActionKeys'] != null) {
            queryParameters['triggerActionKeys'] = requestParameters['triggerActionKeys'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/lead-forms:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for creators to search his/her lead forms
     */
    async searchApiControllerSearchLeadForms(requestParameters: SearchApiControllerSearchLeadFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadFormResponse> {
        const response = await this.searchApiControllerSearchLeadFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches the lead-contact and follower indices together, so a page is a single merged, sorted slice of both. Every row carries a `type` saying which it came from; `promotionalOfferDetails`, `sharePhoneNumberConsent` and a follow `joinDate` are only present on FOLLOWER rows, and `sourceType` / `sourceId` / `sourceDetails` / `leadFormAnswers` only on LEAD rows.
     * for creators to search their followers and collected leads contacts in one list, newest first
     */
    async searchApiControllerSearchLeadsContactsV2Raw(requestParameters: SearchApiControllerSearchLeadsContactsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadsContactsV2Response>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchLeadsContactsV2().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchLeadsContactsV2().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchLeadsContactsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['sourceType'] != null) {
            queryParameters['sourceType'] = requestParameters['sourceType'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['sourceId'] = requestParameters['sourceId'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/stores/{storeId}/leads-contacts:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Searches the lead-contact and follower indices together, so a page is a single merged, sorted slice of both. Every row carries a `type` saying which it came from; `promotionalOfferDetails`, `sharePhoneNumberConsent` and a follow `joinDate` are only present on FOLLOWER rows, and `sourceType` / `sourceId` / `sourceDetails` / `leadFormAnswers` only on LEAD rows.
     * for creators to search their followers and collected leads contacts in one list, newest first
     */
    async searchApiControllerSearchLeadsContactsV2(requestParameters: SearchApiControllerSearchLeadsContactsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadsContactsV2Response> {
        const response = await this.searchApiControllerSearchLeadsContactsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchMyStoreListingsRaw(requestParameters: SearchApiControllerSearchMyStoreListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyStoreListingSearchResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerSearchMyStoreListings().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchMyStoreListings().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchMyStoreListings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['excludeType'] != null) {
            queryParameters['excludeType'] = requestParameters['excludeType'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['filterOutLiveListings'] != null) {
            queryParameters['filterOutLiveListings'] = requestParameters['filterOutLiveListings'];
        }

        if (requestParameters['loadLiveStatus'] != null) {
            queryParameters['loadLiveStatus'] = requestParameters['loadLiveStatus'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        if (requestParameters['soldOut'] != null) {
            queryParameters['soldOut'] = requestParameters['soldOut'];
        }

        if (requestParameters['minPrice'] != null) {
            queryParameters['minPrice'] = requestParameters['minPrice'];
        }

        if (requestParameters['maxPrice'] != null) {
            queryParameters['maxPrice'] = requestParameters['maxPrice'];
        }

        if (requestParameters['shopifyStoreIds'] != null) {
            queryParameters['shopifyStoreIds'] = requestParameters['shopifyStoreIds'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['tagsFilterOperator'] != null) {
            queryParameters['tagsFilterOperator'] = requestParameters['tagsFilterOperator'];
        }

        if (requestParameters['supplierId'] != null) {
            queryParameters['supplierId'] = requestParameters['supplierId'];
        }

        if (requestParameters['partnerId'] != null) {
            queryParameters['partnerId'] = requestParameters['partnerId'];
        }

        if (requestParameters['collectionId'] != null) {
            queryParameters['collectionId'] = requestParameters['collectionId'];
        }

        if (requestParameters['productCategoryId'] != null) {
            queryParameters['productCategoryId'] = requestParameters['productCategoryId'];
        }

        if (requestParameters['includeChildCategories'] != null) {
            queryParameters['includeChildCategories'] = requestParameters['includeChildCategories'];
        }

        if (requestParameters['isDropship'] != null) {
            queryParameters['isDropship'] = requestParameters['isDropship'];
        }

        if (requestParameters['isShopify'] != null) {
            queryParameters['isShopify'] = requestParameters['isShopify'];
        }

        if (requestParameters['minMeetingStartDate'] != null) {
            queryParameters['minMeetingStartDate'] = requestParameters['minMeetingStartDate'];
        }

        if (requestParameters['maxMeetingStartDate'] != null) {
            queryParameters['maxMeetingStartDate'] = requestParameters['maxMeetingStartDate'];
        }

        if (requestParameters['minCreatedAt'] != null) {
            queryParameters['minCreatedAt'] = requestParameters['minCreatedAt'];
        }

        if (requestParameters['maxCreatedAt'] != null) {
            queryParameters['maxCreatedAt'] = requestParameters['maxCreatedAt'];
        }

        if (requestParameters['fromTemplate'] != null) {
            queryParameters['fromTemplate'] = requestParameters['fromTemplate'];
        }

        if (requestParameters['extraState'] != null) {
            queryParameters['extraState'] = requestParameters['extraState'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/listings:search`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchMyStoreListings(requestParameters: SearchApiControllerSearchMyStoreListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyStoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchMyStoreListingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for customers to search his/her submitted lead form submissions
     * @deprecated
     */
    async searchApiControllerSearchMySubmittedCollectedLeadFormSubmissionsRaw(requestParameters: SearchApiControllerSearchMySubmittedCollectedLeadFormSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadFormSubmissionResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling searchApiControllerSearchMySubmittedCollectedLeadFormSubmissions().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchMySubmittedCollectedLeadFormSubmissions().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchMySubmittedCollectedLeadFormSubmissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['leadFormId'] != null) {
            queryParameters['leadFormId'] = requestParameters['leadFormId'];
        }

        if (requestParameters['storeId'] != null) {
            queryParameters['storeId'] = requestParameters['storeId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}/lead-form-submissions:search`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for customers to search his/her submitted lead form submissions
     * @deprecated
     */
    async searchApiControllerSearchMySubmittedCollectedLeadFormSubmissions(requestParameters: SearchApiControllerSearchMySubmittedCollectedLeadFormSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadFormSubmissionResponse> {
        const response = await this.searchApiControllerSearchMySubmittedCollectedLeadFormSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPersonalLooksRaw(requestParameters: SearchApiControllerSearchPersonalLooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPersonalLookResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchPersonalLooks().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPersonalLooks().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPersonalLooks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['isDefault'] != null) {
            queryParameters['isDefault'] = requestParameters['isDefault'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/personal-looks:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPersonalLooks(requestParameters: SearchApiControllerSearchPersonalLooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPersonalLookResponse> {
        const response = await this.searchApiControllerSearchPersonalLooksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPostsRaw(requestParameters: SearchApiControllerSearchPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchPosts().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPosts().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPosts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['permaLink'] != null) {
            queryParameters['permaLink'] = requestParameters['permaLink'];
        }

        if (requestParameters['moderationStatus'] != null) {
            queryParameters['moderationStatus'] = requestParameters['moderationStatus'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['minScheduledReleaseTime'] != null) {
            queryParameters['minScheduledReleaseTime'] = requestParameters['minScheduledReleaseTime'];
        }

        if (requestParameters['maxScheduledReleaseTime'] != null) {
            queryParameters['maxScheduledReleaseTime'] = requestParameters['maxScheduledReleaseTime'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/posts:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPosts(requestParameters: SearchApiControllerSearchPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostSearchResponse> {
        const response = await this.searchApiControllerSearchPostsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPostsCommentsRaw(requestParameters: SearchApiControllerSearchPostsCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostCommentSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchPostsComments().'
            );
        }

        if (requestParameters['postId'] == null) {
            throw new runtime.RequiredError(
                'postId',
                'Required parameter "postId" was null or undefined when calling searchApiControllerSearchPostsComments().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPostsComments().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPostsComments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['rootComment'] != null) {
            queryParameters['rootComment'] = requestParameters['rootComment'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['parentId'] != null) {
            queryParameters['parentId'] = requestParameters['parentId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/posts/{postId}/comments:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));
        urlPath = urlPath.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters['postId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPostsComments(requestParameters: SearchApiControllerSearchPostsCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostCommentSearchResponse> {
        const response = await this.searchApiControllerSearchPostsCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchProductCollectionsRaw(requestParameters: SearchApiControllerSearchProductCollectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCollectionsSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchProductCollections().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchProductCollections().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchProductCollections().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['archived'] != null) {
            queryParameters['archived'] = requestParameters['archived'];
        }

        if (requestParameters['loadLinkedProductCategories'] != null) {
            queryParameters['loadLinkedProductCategories'] = requestParameters['loadLinkedProductCategories'];
        }

        if (requestParameters['layoutType'] != null) {
            queryParameters['layoutType'] = requestParameters['layoutType'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/product-collections:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchProductCollections(requestParameters: SearchApiControllerSearchProductCollectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductCollectionsSearchResponse> {
        const response = await this.searchApiControllerSearchProductCollectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchProfilesFollowersRaw(requestParameters: SearchApiControllerSearchProfilesFollowersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfilesFollowersSearchResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling searchApiControllerSearchProfilesFollowers().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchProfilesFollowers().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchProfilesFollowers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['expand'] != null) {
            queryParameters['expand'] = requestParameters['expand'];
        }

        if (requestParameters['withPhoneNumber'] != null) {
            queryParameters['withPhoneNumber'] = requestParameters['withPhoneNumber'];
        }

        if (requestParameters['withSubscriptionLevel'] != null) {
            queryParameters['withSubscriptionLevel'] = requestParameters['withSubscriptionLevel'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/profiles/{userId}/followers:search`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchProfilesFollowers(requestParameters: SearchApiControllerSearchProfilesFollowersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfilesFollowersSearchResponse> {
        const response = await this.searchApiControllerSearchProfilesFollowersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchPslCategoriesRaw(requestParameters: SearchApiControllerSearchPslCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCategoriesSearchResponse>> {
        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPslCategories().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPslCategories().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['parentId'] != null) {
            queryParameters['parentId'] = requestParameters['parentId'];
        }

        if (requestParameters['isRoot'] != null) {
            queryParameters['isRoot'] = requestParameters['isRoot'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['custom'] != null) {
            queryParameters['custom'] = requestParameters['custom'];
        }

        if (requestParameters['digital'] != null) {
            queryParameters['digital'] = requestParameters['digital'];
        }

        if (requestParameters['loadLinkedGoogleCategories'] != null) {
            queryParameters['loadLinkedGoogleCategories'] = requestParameters['loadLinkedGoogleCategories'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/product-categories:search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchPslCategories(requestParameters: SearchApiControllerSearchPslCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductCategoriesSearchResponse> {
        const response = await this.searchApiControllerSearchPslCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListingsRaw(requestParameters: SearchApiControllerSearchPublicListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreListingSearchResponse>> {
        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPublicListings().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPublicListings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['categoryRowId'] != null) {
            queryParameters['categoryRowId'] = requestParameters['categoryRowId'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['productCategoryId'] != null) {
            queryParameters['productCategoryId'] = requestParameters['productCategoryId'];
        }

        if (requestParameters['includeChildCategories'] != null) {
            queryParameters['includeChildCategories'] = requestParameters['includeChildCategories'];
        }

        if (requestParameters['collectionId'] != null) {
            queryParameters['collectionId'] = requestParameters['collectionId'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        if (requestParameters['sellerTags'] != null) {
            queryParameters['sellerTags'] = requestParameters['sellerTags'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['minQuantity'] != null) {
            queryParameters['minQuantity'] = requestParameters['minQuantity'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['tagsFilterOperator'] != null) {
            queryParameters['tagsFilterOperator'] = requestParameters['tagsFilterOperator'];
        }

        if (requestParameters['sellerIds'] != null) {
            queryParameters['sellerIds'] = requestParameters['sellerIds'];
        }

        if (requestParameters['featured'] != null) {
            queryParameters['featured'] = requestParameters['featured'];
        }

        if (requestParameters['prefetchFeaturedStatus'] != null) {
            queryParameters['prefetchFeaturedStatus'] = requestParameters['prefetchFeaturedStatus'];
        }

        if (requestParameters['listingType'] != null) {
            queryParameters['listingType'] = requestParameters['listingType'];
        }

        if (requestParameters['excludeListingType'] != null) {
            queryParameters['excludeListingType'] = requestParameters['excludeListingType'];
        }

        if (requestParameters['minMeetingStartDate'] != null) {
            queryParameters['minMeetingStartDate'] = requestParameters['minMeetingStartDate'];
        }

        if (requestParameters['maxMeetingStartDate'] != null) {
            queryParameters['maxMeetingStartDate'] = requestParameters['maxMeetingStartDate'];
        }

        if (requestParameters['extraState'] != null) {
            queryParameters['extraState'] = requestParameters['extraState'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/public-listings:search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListings(requestParameters: SearchApiControllerSearchPublicListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchPublicListingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListingsV2Raw(requestParameters: SearchApiControllerSearchPublicListingsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreListingSearchResponse>> {
        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPublicListingsV2().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPublicListingsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['categoryRowId'] != null) {
            queryParameters['categoryRowId'] = requestParameters['categoryRowId'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['productCategoryId'] != null) {
            queryParameters['productCategoryId'] = requestParameters['productCategoryId'];
        }

        if (requestParameters['includeChildCategories'] != null) {
            queryParameters['includeChildCategories'] = requestParameters['includeChildCategories'];
        }

        if (requestParameters['collectionId'] != null) {
            queryParameters['collectionId'] = requestParameters['collectionId'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        if (requestParameters['sellerTags'] != null) {
            queryParameters['sellerTags'] = requestParameters['sellerTags'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['minQuantity'] != null) {
            queryParameters['minQuantity'] = requestParameters['minQuantity'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['tagsFilterOperator'] != null) {
            queryParameters['tagsFilterOperator'] = requestParameters['tagsFilterOperator'];
        }

        if (requestParameters['sellerIds'] != null) {
            queryParameters['sellerIds'] = requestParameters['sellerIds'];
        }

        if (requestParameters['featured'] != null) {
            queryParameters['featured'] = requestParameters['featured'];
        }

        if (requestParameters['prefetchFeaturedStatus'] != null) {
            queryParameters['prefetchFeaturedStatus'] = requestParameters['prefetchFeaturedStatus'];
        }

        if (requestParameters['listingType'] != null) {
            queryParameters['listingType'] = requestParameters['listingType'];
        }

        if (requestParameters['excludeListingType'] != null) {
            queryParameters['excludeListingType'] = requestParameters['excludeListingType'];
        }

        if (requestParameters['minMeetingStartDate'] != null) {
            queryParameters['minMeetingStartDate'] = requestParameters['minMeetingStartDate'];
        }

        if (requestParameters['maxMeetingStartDate'] != null) {
            queryParameters['maxMeetingStartDate'] = requestParameters['maxMeetingStartDate'];
        }

        if (requestParameters['extraState'] != null) {
            queryParameters['extraState'] = requestParameters['extraState'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/public-listings:search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async searchApiControllerSearchPublicListingsV2(requestParameters: SearchApiControllerSearchPublicListingsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreListingSearchResponse> {
        const response = await this.searchApiControllerSearchPublicListingsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for creators to search purchased avatarme images/videos from him/her
     */
    async searchApiControllerSearchPurchasedAvatarMeMediaFromMeRaw(requestParameters: SearchApiControllerSearchPurchasedAvatarMeMediaFromMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPurchasedAvatarMeMediaResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchPurchasedAvatarMeMediaFromMe().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchPurchasedAvatarMeMediaFromMe().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchPurchasedAvatarMeMediaFromMe().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['storeId2'] != null) {
            queryParameters['storeId'] = requestParameters['storeId2'];
        }

        if (requestParameters['variantSku'] != null) {
            queryParameters['variantSku'] = requestParameters['variantSku'];
        }

        if (requestParameters['wearWithAiListingId'] != null) {
            queryParameters['wearWithAiListingId'] = requestParameters['wearWithAiListingId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/purchased-avatar-me-media:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for creators to search purchased avatarme images/videos from him/her
     */
    async searchApiControllerSearchPurchasedAvatarMeMediaFromMe(requestParameters: SearchApiControllerSearchPurchasedAvatarMeMediaFromMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPurchasedAvatarMeMediaResponse> {
        const response = await this.searchApiControllerSearchPurchasedAvatarMeMediaFromMeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerCustomerOrdersRaw(requestParameters: SearchApiControllerSearchSellerCustomerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSellerCustomerOrdersResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerSearchSellerCustomerOrders().'
            );
        }

        if (requestParameters['SearchSellerCustomerOrdersParams'] == null) {
            throw new runtime.RequiredError(
                'SearchSellerCustomerOrdersParams',
                'Required parameter "SearchSellerCustomerOrdersParams" was null or undefined when calling searchApiControllerSearchSellerCustomerOrders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/customer-orders:search`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SearchSellerCustomerOrdersParams'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerCustomerOrders(requestParameters: SearchApiControllerSearchSellerCustomerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSellerCustomerOrdersResponse> {
        const response = await this.searchApiControllerSearchSellerCustomerOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerCustomersRaw(requestParameters: SearchApiControllerSearchSellerCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSellerCustomersResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerSearchSellerCustomers().'
            );
        }

        if (requestParameters['SearchSellerCustomersParams'] == null) {
            throw new runtime.RequiredError(
                'SearchSellerCustomersParams',
                'Required parameter "SearchSellerCustomersParams" was null or undefined when calling searchApiControllerSearchSellerCustomers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/customers:search`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SearchSellerCustomersParams'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerCustomers(requestParameters: SearchApiControllerSearchSellerCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSellerCustomersResponse> {
        const response = await this.searchApiControllerSearchSellerCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerLifeTimeStatsRaw(requestParameters: SearchApiControllerSearchSellerLifeTimeStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSellerLifeTimeStatsResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerSearchSellerLifeTimeStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/lifetime-stats:search`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerLifeTimeStats(requestParameters: SearchApiControllerSearchSellerLifeTimeStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSellerLifeTimeStatsResponse> {
        const response = await this.searchApiControllerSearchSellerLifeTimeStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSellerOrdersRaw(requestParameters: SearchApiControllerSearchSellerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchSellerOrders().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchSellerOrders().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchSellerOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['masterOrderId'] != null) {
            queryParameters['masterOrderId'] = requestParameters['masterOrderId'];
        }

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        if (requestParameters['liveStreamId'] != null) {
            queryParameters['liveStreamId'] = requestParameters['liveStreamId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['orderGroupStatus'] != null) {
            queryParameters['orderGroupStatus'] = requestParameters['orderGroupStatus'];
        }

        if (requestParameters['pickupStatus'] != null) {
            queryParameters['pickupStatus'] = requestParameters['pickupStatus'];
        }

        if (requestParameters['groupStatusMaster'] != null) {
            queryParameters['groupStatusMaster'] = requestParameters['groupStatusMaster'];
        }

        if (requestParameters['groupStatus'] != null) {
            queryParameters['groupStatus'] = requestParameters['groupStatus'];
        }

        if (requestParameters['packed'] != null) {
            queryParameters['packed'] = requestParameters['packed'];
        }

        if (requestParameters['allOrders'] != null) {
            queryParameters['allOrders'] = requestParameters['allOrders'];
        }

        if (requestParameters['shippingMethod'] != null) {
            queryParameters['shippingMethod'] = requestParameters['shippingMethod'];
        }

        if (requestParameters['createdBefore'] != null) {
            queryParameters['createdBefore'] = requestParameters['createdBefore'];
        }

        if (requestParameters['createdAfter'] != null) {
            queryParameters['createdAfter'] = requestParameters['createdAfter'];
        }

        if (requestParameters['couponCode'] != null) {
            queryParameters['couponCode'] = requestParameters['couponCode'];
        }

        if (requestParameters['aggregateTax'] != null) {
            queryParameters['aggregateTax'] = requestParameters['aggregateTax'];
        }

        if (requestParameters['buyerUserType'] != null) {
            queryParameters['buyerUserType'] = requestParameters['buyerUserType'];
        }

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['listingType'] != null) {
            queryParameters['listingType'] = requestParameters['listingType'];
        }

        if (requestParameters['noLiveStreamId'] != null) {
            queryParameters['noLiveStreamId'] = requestParameters['noLiveStreamId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sellerId'] != null) {
            queryParameters['sellerId'] = requestParameters['sellerId'];
        }

        if (requestParameters['buyerId'] != null) {
            queryParameters['buyerId'] = requestParameters['buyerId'];
        }

        if (requestParameters['listingId'] != null) {
            queryParameters['listingId'] = requestParameters['listingId'];
        }

        if (requestParameters['tippingGoalId'] != null) {
            queryParameters['tippingGoalId'] = requestParameters['tippingGoalId'];
        }

        if (requestParameters['minMeetingStartDate'] != null) {
            queryParameters['minMeetingStartDate'] = requestParameters['minMeetingStartDate'];
        }

        if (requestParameters['maxMeetingStartDate'] != null) {
            queryParameters['maxMeetingStartDate'] = requestParameters['maxMeetingStartDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/orders:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSellerOrders(requestParameters: SearchApiControllerSearchSellerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersSearchResponse> {
        const response = await this.searchApiControllerSearchSellerOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSeriesRaw(requestParameters: SearchApiControllerSearchSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchSeries().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchSeries().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchSeries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['accessLevel'] != null) {
            queryParameters['accessLevel'] = requestParameters['accessLevel'];
        }

        if (requestParameters['popClipId'] != null) {
            queryParameters['popClipId'] = requestParameters['popClipId'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['parentId'] != null) {
            queryParameters['parentId'] = requestParameters['parentId'];
        }

        if (requestParameters['archived'] != null) {
            queryParameters['archived'] = requestParameters['archived'];
        }

        if (requestParameters['fromTemplate'] != null) {
            queryParameters['fromTemplate'] = requestParameters['fromTemplate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/series:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSeries(requestParameters: SearchApiControllerSearchSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesSearchResponse> {
        const response = await this.searchApiControllerSearchSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchSeriesElementsV2Raw(requestParameters: SearchApiControllerSearchSeriesElementsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesElementSearchResponseV2>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchSeriesElementsV2().'
            );
        }

        if (requestParameters['seriesId'] == null) {
            throw new runtime.RequiredError(
                'seriesId',
                'Required parameter "seriesId" was null or undefined when calling searchApiControllerSearchSeriesElementsV2().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchSeriesElementsV2().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchSeriesElementsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['popClipId'] != null) {
            queryParameters['popClipId'] = requestParameters['popClipId'];
        }

        if (requestParameters['includeElementsFromSubSeries'] != null) {
            queryParameters['includeElementsFromSubSeries'] = requestParameters['includeElementsFromSubSeries'];
        }

        if (requestParameters['moderationStatus'] != null) {
            queryParameters['moderationStatus'] = requestParameters['moderationStatus'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/stores/{storeId}/series/{seriesId}/elements:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));
        urlPath = urlPath.replace(`{${"seriesId"}}`, encodeURIComponent(String(requestParameters['seriesId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchSeriesElementsV2(requestParameters: SearchApiControllerSearchSeriesElementsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesElementSearchResponseV2> {
        const response = await this.searchApiControllerSearchSeriesElementsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreCommunityChannelMembersRaw(requestParameters: SearchApiControllerSearchStoreCommunityChannelMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommunityChannelMemberSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMembers().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMembers().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMembers().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMembers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['blocked'] != null) {
            queryParameters['blocked'] = requestParameters['blocked'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/community-channels/{channelId}/members:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreCommunityChannelMembers(requestParameters: SearchApiControllerSearchStoreCommunityChannelMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommunityChannelMemberSearchResponse> {
        const response = await this.searchApiControllerSearchStoreCommunityChannelMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreCommunityChannelMessagesRaw(requestParameters: SearchApiControllerSearchStoreCommunityChannelMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommunityChannelMessageSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMessages().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMessages().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMessages().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStoreCommunityChannelMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['parentMessageId'] != null) {
            queryParameters['parentMessageId'] = requestParameters['parentMessageId'];
        }

        if (requestParameters['level'] != null) {
            queryParameters['level'] = requestParameters['level'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['minCreatedAt'] != null) {
            queryParameters['minCreatedAt'] = requestParameters['minCreatedAt'];
        }

        if (requestParameters['maxCreatedAt'] != null) {
            queryParameters['maxCreatedAt'] = requestParameters['maxCreatedAt'];
        }

        if (requestParameters['pinnedOnly'] != null) {
            queryParameters['pinnedOnly'] = requestParameters['pinnedOnly'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/community-channels/{channelId}/messages:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreCommunityChannelMessages(requestParameters: SearchApiControllerSearchStoreCommunityChannelMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommunityChannelMessageSearchResponse> {
        const response = await this.searchApiControllerSearchStoreCommunityChannelMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreCommunityChannelsRaw(requestParameters: SearchApiControllerSearchStoreCommunityChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommunityChannelSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStoreCommunityChannels().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStoreCommunityChannels().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStoreCommunityChannels().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/community-channels:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreCommunityChannels(requestParameters: SearchApiControllerSearchStoreCommunityChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommunityChannelSearchResponse> {
        const response = await this.searchApiControllerSearchStoreCommunityChannelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreGroupEventsRaw(requestParameters: SearchApiControllerSearchStoreGroupEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEventSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStoreGroupEvents().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStoreGroupEvents().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStoreGroupEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['listingId'] != null) {
            queryParameters['listingId'] = requestParameters['listingId'];
        }

        if (requestParameters['locationType'] != null) {
            queryParameters['locationType'] = requestParameters['locationType'];
        }

        if (requestParameters['minStartDate'] != null) {
            queryParameters['minStartDate'] = requestParameters['minStartDate'];
        }

        if (requestParameters['maxStartDate'] != null) {
            queryParameters['maxStartDate'] = requestParameters['maxStartDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/group-events:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreGroupEvents(requestParameters: SearchApiControllerSearchStoreGroupEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEventSearchResponse> {
        const response = await this.searchApiControllerSearchStoreGroupEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreLevelSeriesElementsV2Raw(requestParameters: SearchApiControllerSearchStoreLevelSeriesElementsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesElementSearchResponseV2>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElementsV2().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElementsV2().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStoreLevelSeriesElementsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['popClipId'] != null) {
            queryParameters['popClipId'] = requestParameters['popClipId'];
        }

        if (requestParameters['includeElementsFromSubSeries'] != null) {
            queryParameters['includeElementsFromSubSeries'] = requestParameters['includeElementsFromSubSeries'];
        }

        if (requestParameters['moderationStatus'] != null) {
            queryParameters['moderationStatus'] = requestParameters['moderationStatus'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/stores/{storeId}/series-elements:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreLevelSeriesElementsV2(requestParameters: SearchApiControllerSearchStoreLevelSeriesElementsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesElementSearchResponseV2> {
        const response = await this.searchApiControllerSearchStoreLevelSeriesElementsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStorePollVotesRaw(requestParameters: SearchApiControllerSearchStorePollVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PollVoteSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStorePollVotes().'
            );
        }

        if (requestParameters['pollId'] == null) {
            throw new runtime.RequiredError(
                'pollId',
                'Required parameter "pollId" was null or undefined when calling searchApiControllerSearchStorePollVotes().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStorePollVotes().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStorePollVotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['optionId'] != null) {
            queryParameters['optionId'] = requestParameters['optionId'];
        }

        if (requestParameters['deviceId'] != null) {
            queryParameters['deviceId'] = requestParameters['deviceId'];
        }

        if (requestParameters['unifiedId'] != null) {
            queryParameters['unifiedId'] = requestParameters['unifiedId'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/polls/{pollId}/votes:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));
        urlPath = urlPath.replace(`{${"pollId"}}`, encodeURIComponent(String(requestParameters['pollId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStorePollVotes(requestParameters: SearchApiControllerSearchStorePollVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PollVoteSearchResponse> {
        const response = await this.searchApiControllerSearchStorePollVotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStorePollsRaw(requestParameters: SearchApiControllerSearchStorePollsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PollSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStorePolls().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStorePolls().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStorePolls().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/polls:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStorePolls(requestParameters: SearchApiControllerSearchStorePollsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PollSearchResponse> {
        const response = await this.searchApiControllerSearchStorePollsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchStoreTippingGoalsRaw(requestParameters: SearchApiControllerSearchStoreTippingGoalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TippingGoalSearchResponse>> {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError(
                'storeId',
                'Required parameter "storeId" was null or undefined when calling searchApiControllerSearchStoreTippingGoals().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchStoreTippingGoals().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchStoreTippingGoals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{storeId}/tipping-goals:search`;
        urlPath = urlPath.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters['storeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchStoreTippingGoals(requestParameters: SearchApiControllerSearchStoreTippingGoalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TippingGoalSearchResponse> {
        const response = await this.searchApiControllerSearchStoreTippingGoalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUpcomingShowsRaw(requestParameters: SearchApiControllerSearchUpcomingShowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpcomingShowSearchResponse>> {
        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchUpcomingShows().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchUpcomingShows().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['storeName'] != null) {
            queryParameters['storeName'] = requestParameters['storeName'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['available'] != null) {
            queryParameters['available'] = requestParameters['available'];
        }

        if (requestParameters['noEventId'] != null) {
            queryParameters['noEventId'] = requestParameters['noEventId'];
        }

        if (requestParameters['loadWatchListCount'] != null) {
            queryParameters['loadWatchListCount'] = requestParameters['loadWatchListCount'];
        }

        if (requestParameters['minStartsAt'] != null) {
            queryParameters['minStartsAt'] = requestParameters['minStartsAt'];
        }

        if (requestParameters['maxStartsAt'] != null) {
            queryParameters['maxStartsAt'] = requestParameters['maxStartsAt'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/upcoming-shows:search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUpcomingShows(requestParameters: SearchApiControllerSearchUpcomingShowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpcomingShowSearchResponse> {
        const response = await this.searchApiControllerSearchUpcomingShowsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchApiControllerSearchUserOrdersRaw(requestParameters: SearchApiControllerSearchUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersSearchResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling searchApiControllerSearchUserOrders().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchUserOrders().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchUserOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['masterOrderId'] != null) {
            queryParameters['masterOrderId'] = requestParameters['masterOrderId'];
        }

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        if (requestParameters['liveStreamId'] != null) {
            queryParameters['liveStreamId'] = requestParameters['liveStreamId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['orderGroupStatus'] != null) {
            queryParameters['orderGroupStatus'] = requestParameters['orderGroupStatus'];
        }

        if (requestParameters['pickupStatus'] != null) {
            queryParameters['pickupStatus'] = requestParameters['pickupStatus'];
        }

        if (requestParameters['groupStatusMaster'] != null) {
            queryParameters['groupStatusMaster'] = requestParameters['groupStatusMaster'];
        }

        if (requestParameters['groupStatus'] != null) {
            queryParameters['groupStatus'] = requestParameters['groupStatus'];
        }

        if (requestParameters['packed'] != null) {
            queryParameters['packed'] = requestParameters['packed'];
        }

        if (requestParameters['allOrders'] != null) {
            queryParameters['allOrders'] = requestParameters['allOrders'];
        }

        if (requestParameters['shippingMethod'] != null) {
            queryParameters['shippingMethod'] = requestParameters['shippingMethod'];
        }

        if (requestParameters['createdBefore'] != null) {
            queryParameters['createdBefore'] = requestParameters['createdBefore'];
        }

        if (requestParameters['createdAfter'] != null) {
            queryParameters['createdAfter'] = requestParameters['createdAfter'];
        }

        if (requestParameters['couponCode'] != null) {
            queryParameters['couponCode'] = requestParameters['couponCode'];
        }

        if (requestParameters['aggregateTax'] != null) {
            queryParameters['aggregateTax'] = requestParameters['aggregateTax'];
        }

        if (requestParameters['buyerUserType'] != null) {
            queryParameters['buyerUserType'] = requestParameters['buyerUserType'];
        }

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['listingType'] != null) {
            queryParameters['listingType'] = requestParameters['listingType'];
        }

        if (requestParameters['noLiveStreamId'] != null) {
            queryParameters['noLiveStreamId'] = requestParameters['noLiveStreamId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sellerId'] != null) {
            queryParameters['sellerId'] = requestParameters['sellerId'];
        }

        if (requestParameters['buyerId'] != null) {
            queryParameters['buyerId'] = requestParameters['buyerId'];
        }

        if (requestParameters['listingId'] != null) {
            queryParameters['listingId'] = requestParameters['listingId'];
        }

        if (requestParameters['tippingGoalId'] != null) {
            queryParameters['tippingGoalId'] = requestParameters['tippingGoalId'];
        }

        if (requestParameters['minMeetingStartDate'] != null) {
            queryParameters['minMeetingStartDate'] = requestParameters['minMeetingStartDate'];
        }

        if (requestParameters['maxMeetingStartDate'] != null) {
            queryParameters['maxMeetingStartDate'] = requestParameters['maxMeetingStartDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}/orders:search`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchApiControllerSearchUserOrders(requestParameters: SearchApiControllerSearchUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersSearchResponse> {
        const response = await this.searchApiControllerSearchUserOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * search withdraw transactions in seller dashboard
     * 
     */
    async searchApiControllerSearchWithdrawTransactionsBySellerRaw(requestParameters: SearchApiControllerSearchWithdrawTransactionsBySellerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WithdrawTransactionsSearchResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling searchApiControllerSearchWithdrawTransactionsBySeller().'
            );
        }

        if (requestParameters['pageNo'] == null) {
            throw new runtime.RequiredError(
                'pageNo',
                'Required parameter "pageNo" was null or undefined when calling searchApiControllerSearchWithdrawTransactionsBySeller().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling searchApiControllerSearchWithdrawTransactionsBySeller().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['minCreatedAt'] != null) {
            queryParameters['minCreatedAt'] = requestParameters['minCreatedAt'];
        }

        if (requestParameters['maxCreatedAt'] != null) {
            queryParameters['maxCreatedAt'] = requestParameters['maxCreatedAt'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/withdraw-transactions:search`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * search withdraw transactions in seller dashboard
     * 
     */
    async searchApiControllerSearchWithdrawTransactionsBySeller(requestParameters: SearchApiControllerSearchWithdrawTransactionsBySellerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WithdrawTransactionsSearchResponse> {
        const response = await this.searchApiControllerSearchWithdrawTransactionsBySellerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerExportSellerOrderDetailsOrderEnum = typeof SearchApiControllerExportSellerOrderDetailsOrderEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsOrderEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type SearchApiControllerExportSellerOrderDetailsStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum = {
    Open: 'open',
    Processing: 'processing',
    Fulfilling: 'fulfilling',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsOrderGroupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsPickupStatusEnum = {
    Open: 'open',
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Packed: 'packed',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type SearchApiControllerExportSellerOrderDetailsPickupStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsPickupStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsPickupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsGroupStatusEnum = {
    Master: 'master',
    Customer: 'customer'
} as const;
export type SearchApiControllerExportSellerOrderDetailsGroupStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsGroupStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsGroupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsShippingMethodEnum = {
    DropshipSupplierProvide: 'dropshipSupplierProvide',
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup'
} as const;
export type SearchApiControllerExportSellerOrderDetailsShippingMethodEnum = typeof SearchApiControllerExportSellerOrderDetailsShippingMethodEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsShippingMethodEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum = {
    Guest: 'guest',
    Normal: 'normal',
    Seller: 'seller',
    VerifiedSeller: 'verifiedSeller'
} as const;
export type SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum = typeof SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsBuyerUserTypeEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsPlatformEnum = {
    PopshopLive: 'popshop.live',
    PopStore: 'pop.store'
} as const;
export type SearchApiControllerExportSellerOrderDetailsPlatformEnum = typeof SearchApiControllerExportSellerOrderDetailsPlatformEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerExportSellerOrderDetailsListingTypeEnum = typeof SearchApiControllerExportSellerOrderDetailsListingTypeEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsMainStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type SearchApiControllerExportSellerOrderDetailsMainStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsMainStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsMainStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum = {
    Disabled: 'disabled',
    NoLabel: 'noLabel',
    Generating: 'generating',
    Generated: 'generated',
    PreGenerated: 'preGenerated',
    Failed: 'failed'
} as const;
export type SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsShippingLabelStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum = {
    Disabled: 'disabled',
    NoLabel: 'noLabel',
    Generating: 'generating',
    Generated: 'generated',
    PreGenerated: 'preGenerated',
    Failed: 'failed'
} as const;
export type SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsMainShippingLabelStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsShippingStatusEnum = {
    Unknown: 'UNKNOWN',
    Delivered: 'DELIVERED',
    PreTransit: 'PRE_TRANSIT',
    Transit: 'TRANSIT',
    Failure: 'FAILURE',
    Returned: 'RETURNED'
} as const;
export type SearchApiControllerExportSellerOrderDetailsShippingStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsShippingStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsShippingStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsRateStatusEnum = {
    Pending: 'pending',
    Failed: 'failed',
    Success: 'success'
} as const;
export type SearchApiControllerExportSellerOrderDetailsRateStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsRateStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsRateStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum = {
    Unknown: 'UNKNOWN',
    Delivered: 'DELIVERED',
    PreTransit: 'PRE_TRANSIT',
    Transit: 'TRANSIT',
    Failure: 'FAILURE',
    Returned: 'RETURNED'
} as const;
export type SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsMainShippingStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum = {
    Opened: 'Opened',
    NeedLabel: 'NeedLabel',
    Generated: 'Generated',
    FlatRate: 'FlatRate',
    Cancelled: 'Cancelled'
} as const;
export type SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum = typeof SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsFilterLabelStatusEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsSortByEnum = {
    BuyerFullName: 'buyerFullName',
    OrderNumber: 'orderNumber',
    Total: 'total',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Bonus: 'bonus',
    ShippingFee: 'shippingFee',
    PickupStatus: 'pickupStatus',
    TotalPriceIncludeSlaveOrders: 'totalPriceIncludeSlaveOrders',
    ListingQuantity: 'listingQuantity',
    ListingWeightInLb: 'listingWeightInLb',
    AdjustShippingFee: 'adjustShippingFee'
} as const;
export type SearchApiControllerExportSellerOrderDetailsSortByEnum = typeof SearchApiControllerExportSellerOrderDetailsSortByEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsSortByEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum = {
    Credit: 'credit',
    Applepay: 'applepay',
    Empty: 'empty'
} as const;
export type SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum = typeof SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsPaymentTypeEnum];
/**
 * @export
 */
export const SearchApiControllerExportSellerOrderDetailsSourceTypeEnum = {
    UpcomingShow: 'UPCOMING_SHOW',
    LiveStream: 'LIVE_STREAM',
    Store: 'STORE',
    TwoWayStream: 'TWO_WAY_STREAM',
    ReferralGifting: 'REFERRAL_GIFTING',
    SendItem: 'SEND_ITEM',
    TopProducts: 'TOP_PRODUCTS',
    Shop: 'SHOP',
    Replay: 'REPLAY',
    CommentChat: 'COMMENT_CHAT'
} as const;
export type SearchApiControllerExportSellerOrderDetailsSourceTypeEnum = typeof SearchApiControllerExportSellerOrderDetailsSourceTypeEnum[keyof typeof SearchApiControllerExportSellerOrderDetailsSourceTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchAccountsXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type SearchApiControllerSearchAccountsXPopPlatformEnum = typeof SearchApiControllerSearchAccountsXPopPlatformEnum[keyof typeof SearchApiControllerSearchAccountsXPopPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchMyStoreListingsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchMyStoreListingsOrderEnum = typeof SearchApiControllerSearchMyStoreListingsOrderEnum[keyof typeof SearchApiControllerSearchMyStoreListingsOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchMyStoreListingsTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchMyStoreListingsTypeEnum = typeof SearchApiControllerSearchMyStoreListingsTypeEnum[keyof typeof SearchApiControllerSearchMyStoreListingsTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchMyStoreListingsExcludeTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchMyStoreListingsExcludeTypeEnum = typeof SearchApiControllerSearchMyStoreListingsExcludeTypeEnum[keyof typeof SearchApiControllerSearchMyStoreListingsExcludeTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchMyStoreListingsStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type SearchApiControllerSearchMyStoreListingsStatusEnum = typeof SearchApiControllerSearchMyStoreListingsStatusEnum[keyof typeof SearchApiControllerSearchMyStoreListingsStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchMyStoreListingsSortByEnum = {
    Id: 'id',
    Name: 'name',
    CreatedAt: 'createdAt',
    Quantity: 'quantity',
    Price: 'price',
    DiscountPrice: 'discountPrice',
    ShippingFee: 'shippingFee',
    MeetingStartDate: 'meeting.startDate'
} as const;
export type SearchApiControllerSearchMyStoreListingsSortByEnum = typeof SearchApiControllerSearchMyStoreListingsSortByEnum[keyof typeof SearchApiControllerSearchMyStoreListingsSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum = {
    ContainsAny: 'CONTAINS_ANY',
    ContainsAll: 'CONTAINS_ALL',
    NotContainsAny: 'NOT_CONTAINS_ANY',
    NotContainsAll: 'NOT_CONTAINS_ALL'
} as const;
export type SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum = typeof SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum[keyof typeof SearchApiControllerSearchMyStoreListingsTagsFilterOperatorEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPostsXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type SearchApiControllerSearchPostsXPopPlatformEnum = typeof SearchApiControllerSearchPostsXPopPlatformEnum[keyof typeof SearchApiControllerSearchPostsXPopPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchProductCollectionsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchProductCollectionsOrderEnum = typeof SearchApiControllerSearchProductCollectionsOrderEnum[keyof typeof SearchApiControllerSearchProductCollectionsOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchProductCollectionsSortByEnum = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
    Sort: 'sort'
} as const;
export type SearchApiControllerSearchProductCollectionsSortByEnum = typeof SearchApiControllerSearchProductCollectionsSortByEnum[keyof typeof SearchApiControllerSearchProductCollectionsSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchProductsXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type SearchApiControllerSearchProductsXPopPlatformEnum = typeof SearchApiControllerSearchProductsXPopPlatformEnum[keyof typeof SearchApiControllerSearchProductsXPopPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchProfilesFollowersOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchProfilesFollowersOrderEnum = typeof SearchApiControllerSearchProfilesFollowersOrderEnum[keyof typeof SearchApiControllerSearchProfilesFollowersOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchProfilesFollowersSortByEnum = {
    Id: 'id',
    Username: 'username',
    FirstName: 'firstName',
    LastName: 'lastName',
    StoreFrontName: 'storeFrontName',
    Timestamp: 'timestamp'
} as const;
export type SearchApiControllerSearchProfilesFollowersSortByEnum = typeof SearchApiControllerSearchProfilesFollowersSortByEnum[keyof typeof SearchApiControllerSearchProfilesFollowersSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPslCategoriesOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchPslCategoriesOrderEnum = typeof SearchApiControllerSearchPslCategoriesOrderEnum[keyof typeof SearchApiControllerSearchPslCategoriesOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPslCategoriesSortByEnum = {
    Id: 'id',
    CreatedAt: 'createdAt',
    Name: 'name',
    Sort: 'sort'
} as const;
export type SearchApiControllerSearchPslCategoriesSortByEnum = typeof SearchApiControllerSearchPslCategoriesSortByEnum[keyof typeof SearchApiControllerSearchPslCategoriesSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchPublicListingsOrderEnum = typeof SearchApiControllerSearchPublicListingsOrderEnum[keyof typeof SearchApiControllerSearchPublicListingsOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type SearchApiControllerSearchPublicListingsStatusEnum = typeof SearchApiControllerSearchPublicListingsStatusEnum[keyof typeof SearchApiControllerSearchPublicListingsStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsSortByEnum = {
    Id: 'id',
    Name: 'name',
    CreatedAt: 'createdAt',
    Quantity: 'quantity',
    Price: 'price',
    DiscountPrice: 'discountPrice',
    ShippingFee: 'shippingFee',
    SoldQuantityLast7Days: 'soldQuantityLast7Days',
    StoreFrontNameKeyword: 'storeFrontName.keyword',
    MeetingStartDate: 'meeting.startDate'
} as const;
export type SearchApiControllerSearchPublicListingsSortByEnum = typeof SearchApiControllerSearchPublicListingsSortByEnum[keyof typeof SearchApiControllerSearchPublicListingsSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum = {
    ContainsAny: 'CONTAINS_ANY',
    ContainsAll: 'CONTAINS_ALL',
    NotContainsAny: 'NOT_CONTAINS_ANY',
    NotContainsAll: 'NOT_CONTAINS_ALL'
} as const;
export type SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum = typeof SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum[keyof typeof SearchApiControllerSearchPublicListingsTagsFilterOperatorEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchPublicListingsListingTypeEnum = typeof SearchApiControllerSearchPublicListingsListingTypeEnum[keyof typeof SearchApiControllerSearchPublicListingsListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsExcludeListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchPublicListingsExcludeListingTypeEnum = typeof SearchApiControllerSearchPublicListingsExcludeListingTypeEnum[keyof typeof SearchApiControllerSearchPublicListingsExcludeListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type SearchApiControllerSearchPublicListingsXPopPlatformEnum = typeof SearchApiControllerSearchPublicListingsXPopPlatformEnum[keyof typeof SearchApiControllerSearchPublicListingsXPopPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2OrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchPublicListingsV2OrderEnum = typeof SearchApiControllerSearchPublicListingsV2OrderEnum[keyof typeof SearchApiControllerSearchPublicListingsV2OrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2StatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type SearchApiControllerSearchPublicListingsV2StatusEnum = typeof SearchApiControllerSearchPublicListingsV2StatusEnum[keyof typeof SearchApiControllerSearchPublicListingsV2StatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2SortByEnum = {
    Id: 'id',
    Name: 'name',
    CreatedAt: 'createdAt',
    Quantity: 'quantity',
    Price: 'price',
    DiscountPrice: 'discountPrice',
    ShippingFee: 'shippingFee',
    SoldQuantityLast7Days: 'soldQuantityLast7Days',
    StoreFrontNameKeyword: 'storeFrontName.keyword',
    MeetingStartDate: 'meeting.startDate'
} as const;
export type SearchApiControllerSearchPublicListingsV2SortByEnum = typeof SearchApiControllerSearchPublicListingsV2SortByEnum[keyof typeof SearchApiControllerSearchPublicListingsV2SortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum = {
    ContainsAny: 'CONTAINS_ANY',
    ContainsAll: 'CONTAINS_ALL',
    NotContainsAny: 'NOT_CONTAINS_ANY',
    NotContainsAll: 'NOT_CONTAINS_ALL'
} as const;
export type SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum = typeof SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum[keyof typeof SearchApiControllerSearchPublicListingsV2TagsFilterOperatorEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2ListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchPublicListingsV2ListingTypeEnum = typeof SearchApiControllerSearchPublicListingsV2ListingTypeEnum[keyof typeof SearchApiControllerSearchPublicListingsV2ListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum = typeof SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum[keyof typeof SearchApiControllerSearchPublicListingsV2ExcludeListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchPublicListingsV2XPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type SearchApiControllerSearchPublicListingsV2XPopPlatformEnum = typeof SearchApiControllerSearchPublicListingsV2XPopPlatformEnum[keyof typeof SearchApiControllerSearchPublicListingsV2XPopPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchSellerOrdersOrderEnum = typeof SearchApiControllerSearchSellerOrdersOrderEnum[keyof typeof SearchApiControllerSearchSellerOrdersOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type SearchApiControllerSearchSellerOrdersStatusEnum = typeof SearchApiControllerSearchSellerOrdersStatusEnum[keyof typeof SearchApiControllerSearchSellerOrdersStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum = {
    Open: 'open',
    Processing: 'processing',
    Fulfilling: 'fulfilling',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum = typeof SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum[keyof typeof SearchApiControllerSearchSellerOrdersOrderGroupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersPickupStatusEnum = {
    Open: 'open',
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Packed: 'packed',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type SearchApiControllerSearchSellerOrdersPickupStatusEnum = typeof SearchApiControllerSearchSellerOrdersPickupStatusEnum[keyof typeof SearchApiControllerSearchSellerOrdersPickupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersGroupStatusEnum = {
    Master: 'master',
    Customer: 'customer'
} as const;
export type SearchApiControllerSearchSellerOrdersGroupStatusEnum = typeof SearchApiControllerSearchSellerOrdersGroupStatusEnum[keyof typeof SearchApiControllerSearchSellerOrdersGroupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersShippingMethodEnum = {
    DropshipSupplierProvide: 'dropshipSupplierProvide',
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup'
} as const;
export type SearchApiControllerSearchSellerOrdersShippingMethodEnum = typeof SearchApiControllerSearchSellerOrdersShippingMethodEnum[keyof typeof SearchApiControllerSearchSellerOrdersShippingMethodEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum = {
    Guest: 'guest',
    Normal: 'normal',
    Seller: 'seller',
    VerifiedSeller: 'verifiedSeller'
} as const;
export type SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum = typeof SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum[keyof typeof SearchApiControllerSearchSellerOrdersBuyerUserTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersPlatformEnum = {
    PopshopLive: 'popshop.live',
    PopStore: 'pop.store'
} as const;
export type SearchApiControllerSearchSellerOrdersPlatformEnum = typeof SearchApiControllerSearchSellerOrdersPlatformEnum[keyof typeof SearchApiControllerSearchSellerOrdersPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchSellerOrdersListingTypeEnum = typeof SearchApiControllerSearchSellerOrdersListingTypeEnum[keyof typeof SearchApiControllerSearchSellerOrdersListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSellerOrdersSortByEnum = {
    BuyerFullName: 'buyerFullName',
    OrderNumber: 'orderNumber',
    Total: 'total',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Bonus: 'bonus',
    ShippingFee: 'shippingFee',
    PickupStatus: 'pickupStatus'
} as const;
export type SearchApiControllerSearchSellerOrdersSortByEnum = typeof SearchApiControllerSearchSellerOrdersSortByEnum[keyof typeof SearchApiControllerSearchSellerOrdersSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSeriesOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchSeriesOrderEnum = typeof SearchApiControllerSearchSeriesOrderEnum[keyof typeof SearchApiControllerSearchSeriesOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSeriesSortByEnum = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
    Sort: 'sort'
} as const;
export type SearchApiControllerSearchSeriesSortByEnum = typeof SearchApiControllerSearchSeriesSortByEnum[keyof typeof SearchApiControllerSearchSeriesSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchSeriesElementsV2OrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchSeriesElementsV2OrderEnum = typeof SearchApiControllerSearchSeriesElementsV2OrderEnum[keyof typeof SearchApiControllerSearchSeriesElementsV2OrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum = typeof SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum[keyof typeof SearchApiControllerSearchStoreLevelSeriesElementsV2OrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchThemeTemplatesOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchThemeTemplatesOrderEnum = typeof SearchApiControllerSearchThemeTemplatesOrderEnum[keyof typeof SearchApiControllerSearchThemeTemplatesOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchThemeTemplatesSortByEnum = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Position: 'position'
} as const;
export type SearchApiControllerSearchThemeTemplatesSortByEnum = typeof SearchApiControllerSearchThemeTemplatesSortByEnum[keyof typeof SearchApiControllerSearchThemeTemplatesSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUpcomingShowsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchUpcomingShowsOrderEnum = typeof SearchApiControllerSearchUpcomingShowsOrderEnum[keyof typeof SearchApiControllerSearchUpcomingShowsOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUpcomingShowsSortByEnum = {
    StartsAt: 'startsAt'
} as const;
export type SearchApiControllerSearchUpcomingShowsSortByEnum = typeof SearchApiControllerSearchUpcomingShowsSortByEnum[keyof typeof SearchApiControllerSearchUpcomingShowsSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchUserOrdersOrderEnum = typeof SearchApiControllerSearchUserOrdersOrderEnum[keyof typeof SearchApiControllerSearchUserOrdersOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type SearchApiControllerSearchUserOrdersStatusEnum = typeof SearchApiControllerSearchUserOrdersStatusEnum[keyof typeof SearchApiControllerSearchUserOrdersStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersOrderGroupStatusEnum = {
    Open: 'open',
    Processing: 'processing',
    Fulfilling: 'fulfilling',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type SearchApiControllerSearchUserOrdersOrderGroupStatusEnum = typeof SearchApiControllerSearchUserOrdersOrderGroupStatusEnum[keyof typeof SearchApiControllerSearchUserOrdersOrderGroupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersPickupStatusEnum = {
    Open: 'open',
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Packed: 'packed',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type SearchApiControllerSearchUserOrdersPickupStatusEnum = typeof SearchApiControllerSearchUserOrdersPickupStatusEnum[keyof typeof SearchApiControllerSearchUserOrdersPickupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersGroupStatusEnum = {
    Master: 'master',
    Customer: 'customer'
} as const;
export type SearchApiControllerSearchUserOrdersGroupStatusEnum = typeof SearchApiControllerSearchUserOrdersGroupStatusEnum[keyof typeof SearchApiControllerSearchUserOrdersGroupStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersShippingMethodEnum = {
    DropshipSupplierProvide: 'dropshipSupplierProvide',
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup'
} as const;
export type SearchApiControllerSearchUserOrdersShippingMethodEnum = typeof SearchApiControllerSearchUserOrdersShippingMethodEnum[keyof typeof SearchApiControllerSearchUserOrdersShippingMethodEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersBuyerUserTypeEnum = {
    Guest: 'guest',
    Normal: 'normal',
    Seller: 'seller',
    VerifiedSeller: 'verifiedSeller'
} as const;
export type SearchApiControllerSearchUserOrdersBuyerUserTypeEnum = typeof SearchApiControllerSearchUserOrdersBuyerUserTypeEnum[keyof typeof SearchApiControllerSearchUserOrdersBuyerUserTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersPlatformEnum = {
    PopshopLive: 'popshop.live',
    PopStore: 'pop.store'
} as const;
export type SearchApiControllerSearchUserOrdersPlatformEnum = typeof SearchApiControllerSearchUserOrdersPlatformEnum[keyof typeof SearchApiControllerSearchUserOrdersPlatformEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersListingTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type SearchApiControllerSearchUserOrdersListingTypeEnum = typeof SearchApiControllerSearchUserOrdersListingTypeEnum[keyof typeof SearchApiControllerSearchUserOrdersListingTypeEnum];
/**
 * @export
 */
export const SearchApiControllerSearchUserOrdersSortByEnum = {
    BuyerFullName: 'buyerFullName',
    OrderNumber: 'orderNumber',
    Total: 'total',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Bonus: 'bonus',
    ShippingFee: 'shippingFee',
    PickupStatus: 'pickupStatus'
} as const;
export type SearchApiControllerSearchUserOrdersSortByEnum = typeof SearchApiControllerSearchUserOrdersSortByEnum[keyof typeof SearchApiControllerSearchUserOrdersSortByEnum];
/**
 * @export
 */
export const SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum = typeof SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum[keyof typeof SearchApiControllerSearchWithdrawTransactionsBySellerOrderEnum];
/**
 * @export
 */
export const SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;
export type SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum = typeof SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum[keyof typeof SearchApiControllerSearchWithdrawTransactionsBySellerStatusEnum];
/**
 * @export
 */
export const SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Amount: 'amount',
    Balance: 'balance'
} as const;
export type SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum = typeof SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum[keyof typeof SearchApiControllerSearchWithdrawTransactionsBySellerSortByEnum];
